/** Amplitude en pixels sous laquelle un défilement est ignoré, pour ne pas clignoter au moindre geste. */
const SCROLL_THRESHOLD = 8;

/** Hauteur de défilement sous laquelle la barre reste visible : en haut de page rien ne la cache. */
const ALWAYS_VISIBLE_OFFSET = 120;

const MOBILE_QUERY = matchMedia('(max-width: 749px)');

const getScrollTop = () => document.scrollingElement?.scrollTop ?? window.scrollY;

/**
 * Barre « Filtrer et trier » collée en bas de l'écran sur mobile.
 *
 * Elle se masque au défilement vers le bas et revient au défilement vers le haut, pour ne pas
 * amputer la hauteur d'écran pendant la lecture de la grille.
 */
class FacetsStickyToggle extends HTMLElement {
  #lastScrollTop = 0;
  /** @type {number} */
  #frame = 0;

  connectedCallback() {
    this.#lastScrollTop = getScrollTop();
    this.dataset.state = 'visible';

    window.addEventListener('scroll', this.#handleScroll, { passive: true });
    MOBILE_QUERY.addEventListener('change', this.#handleBreakpointChange);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.#handleScroll);
    MOBILE_QUERY.removeEventListener('change', this.#handleBreakpointChange);
    if (this.#frame) cancelAnimationFrame(this.#frame);
    this.#frame = 0;
  }

  /* Repasser en desktop puis en mobile ne doit pas ramener une barre masquée par un défilement d'avant. */
  #handleBreakpointChange = () => {
    this.#lastScrollTop = getScrollTop();
    this.dataset.state = 'visible';
  };

  #handleScroll = () => {
    if (this.#frame) return;
    this.#frame = requestAnimationFrame(this.#update);
  };

  #update = () => {
    this.#frame = 0;
    if (!MOBILE_QUERY.matches) return;

    /*
     * Le tiroir de filtres verrouille le défilement en passant le body en position: fixed, ce qui
     * remet le document à 0 puis le restaure à la fermeture : ces sauts ne sont pas des gestes.
     */
    if (document.body.style.position === 'fixed') return;

    const scrollTop = getScrollTop();
    const delta = scrollTop - this.#lastScrollTop;
    if (Math.abs(delta) < SCROLL_THRESHOLD) return;

    this.#lastScrollTop = scrollTop;
    this.dataset.state = delta < 0 || scrollTop < ALWAYS_VISIBLE_OFFSET ? 'visible' : 'hidden';
  };
}

if (!customElements.get('facets-sticky-toggle')) {
  customElements.define('facets-sticky-toggle', FacetsStickyToggle);
}
